<div class="modal-container" [class.minimised]="minimise">
  <!-- Modal Header -->
  <div class="modal-header">
    <h3 class="modal-title">{{title}}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="toggleMinimize()"></i>
      <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
  </div>

  <!-- Issue Description -->
  @if (ISSUE_DESC) {
<table cellspacing="1" cellpadding="1" style="width:100%">
    <tr style="height:50px;">
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%;vertical-align:middle;text-align:left"><b>Issue: {{ISSUE_DESC}}</b></td>
    </tr>
  </table>
}

  <!-- Modal Body -->
  @if (!minimise) {
<div class="modal-body">
    <div class="form-horizontal">
      <!-- Loader -->
      @if (showFormLoader) {
<div class="row formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- No Partners Message -->
      @if (!showFormLoader && !arePartnerPresent) {
<div class="row data-align-center">
        <b>There are no Partner listed under this HO.</b>
      </div>
}

      <!-- Main Form Content -->
      @if (!showFormLoader && arePartnerPresent) {
<div class="row">
        <!-- Entity Details Table -->
        <table class="table table-bordered form-inline enityDetails">
          <tr>
            @for (key of objectKeys(entityList); track $index) {
<td>
              <span>{{key}}</span>
            </td>
}
          </tr>
          <tr>
            @for (key of objectKeys(entityList); track $index) {
<td>
              <span>{{entityList[key]}}</span>
            </td>
}
          </tr>
        </table>

        <!-- Information About the Partnership -->
        <table class="table table-bordered form-inline K_Entry">
          <thead>
            <tr>
              <th colspan="3" class="data-align-center">Information About the Partnership</th>
            </tr>
          </thead>
          <tbody>
            @if (formattedScheduleKData['C'] && formattedScheduleKData['C'][0]) {
<tr>
              <td style="width: 8px;">C</td>
              <td class="data-align-left">{{formattedScheduleKData['C'][0].LINE_DESCRIPTION}}</td>
              <td class="data-align-left">
                <input type="text" 
                       [(ngModel)]="formattedScheduleKData['C'][0].ATTRIB_VALUE" 
                       class="form-control input-sm data-width" 
                       maxlength="12"
                       (ngModelChange)="setLineValueForAll('C')">
              </td>
            </tr>
}
            @if (formattedScheduleKData['D'] && formattedScheduleKData['D'][0]) {
<tr>
              <td style="width: 8px;">D</td>
              <td class="data-align-left">{{formattedScheduleKData['D'][0].LINE_DESCRIPTION}}</td>
              <td class="data-align-left">
                <input type="checkbox" 
                       [(ngModel)]="formattedScheduleKData['D'][0].ATTRIB_VALUE"
                       (ngModelChange)="setLineValueForAll('D')">
              </td>
            </tr>
}
          </tbody>
        </table>

        <!-- Information About the Partner -->
        <table class="table table-bordered form-inline">
          <thead>
            <tr>
              <th class="data-align-center">Information About the Partner</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <!-- Partner Info Table (G, H1, H2, I1, I2) -->
                <table class="table table-bordered form-inline partner-info-table">
                  <tbody>
                    <tr>
                      <td rowspan="2">Legal Entity</td>
                      <td colspan="2">G</td>
                      <td colspan="2">H1</td>
                      <td colspan="3">H2</td>
                      <td>I1</td>
                      <td>I2</td>
                    </tr>
                    <tr>
                      <td style="width: 5%;">General partner or LLC member-manager</td>
                      <td style="width: 5%;">Limited partner or other LLC member</td>
                      <td style="width: 5%;">Domestic Partner</td>
                      <td style="width: 5%;">Foreign Partner</td>
                      <td style="width: 5%;">Disregarded Entity (DE)</td>
                      <td style="width: 16%;">TIN</td>
                      <td style="width: 16%;">Name</td>
                      <td style="width: 18%;">What type of entity is this partner?</td>
                      <td style="width: 5%;">If this partner is a retirement plan (IRA/SEP/Keogh/etc.), check here</td>
                    </tr>
                    @for (row of formattedScheduleKData['J1']; track $index; let i = $index) {
<tr>
                      <td>{{row.LEID + ' - ' + row.LE_NAME}}</td>
                      <td>
                        @if (formattedScheduleKData['G']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['G'][i].ATTRIB_VALUE"
                               (ngModelChange)="unselectOtherG('G', i)">
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['G1']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['G1'][i].ATTRIB_VALUE"
                               (ngModelChange)="unselectOtherG('G1', i)">
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['H1']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['H1'][i].ATTRIB_VALUE"
                               [disabled]="!formattedScheduleKData['H1']?.[i]?.DOMESTIC_EDIT_FLAG"
                               (ngModelChange)="unselectOtherH('H1', i)">
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['H1(2)']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['H1(2)'][i].ATTRIB_VALUE"
                               [disabled]="!formattedScheduleKData['H1(2)']?.[i]?.FOREIGN_EDIT_FLAG"
                               (ngModelChange)="unselectOtherH('H1(2)', i)">
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['H2']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['H2'][i].ATTRIB_VALUE"
                               disabled>
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['H2(1)']?.[i]) {
<input type="text" 
                              
                               [(ngModel)]="formattedScheduleKData['H2(1)'][i].ATTRIB_VALUE" 
                               class="form-control input-sm data-width" 
                               disabled>
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['H2(2)']?.[i]) {
<input type="text" 
                              
                               [(ngModel)]="formattedScheduleKData['H2(2)'][i].ATTRIB_VALUE" 
                               class="form-control input-sm data-width" 
                               disabled>
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['I1']?.[i]) {
<input type="text" 
                              
                               [(ngModel)]="formattedScheduleKData['I1'][i].ATTRIB_VALUE" 
                               class="form-control input-sm data-width" 
                               disabled>
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['I2']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['I2'][i].ATTRIB_VALUE">
}
                      </td>
                    </tr>
}
                  </tbody>
                </table>

                <!-- J Section - Partner's share of profit, loss, and capital -->
                <table class="table table-bordered form-inline">
                  <tbody>
                    <tr>
                      <td [attr.rowspan]="(formattedScheduleKData['J1']?.length || 0) + 2">J</td>
                      <td>Partner's share of profit, loss, and capital (see instructions):</td>
                      <td>Profit(B)</td>
                      <td>Loss(B)</td>
                      <td>Capital(B)</td>
                      <td>Profit(E)</td>
                      <td>Loss(E)</td>
                      <td>Capital(E)</td>
                      <td style="width: 5%;">
                        Check if decrease
                        <i class="fa fa-info-circle" title="Check if decrease is due to sale or exchange of partnership interest"></i>
                      </td>
                    </tr>
                    @for (row of formattedScheduleKData['J1']; track $index; let i = $index) {
<tr>
                      <td>{{row.LEID + ' - ' + row.LE_NAME}}</td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <input type="text" 
                                 [(ngModel)]="row['PROFIT(B)']" 
                                 class="form-control input-sm"
                                 [ngClass]="{'show-red': row['PROFIT(B)'] > 100 || row['PROFIT(B)'] < 0}"
                                 (ngModelChange)="validationForJ('J1', i, 'PROFIT(B)')"
                                 maxlength="9">
                          <span class="input-group-addon">%</span>
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <input type="text" 
                                 [(ngModel)]="row['LOSS(B)']" 
                                 class="form-control input-sm"
                                 [ngClass]="{'show-red': row['LOSS(B)'] > 100 || row['LOSS(B)'] < 0}"
                                 (ngModelChange)="validationForJ('J1', i, 'LOSS(B)')"
                                 maxlength="9">
                          <span class="input-group-addon">%</span>
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <input type="text" 
                                 [(ngModel)]="row['CAPITAL(B)']" 
                                 class="form-control input-sm"
                                 [ngClass]="{'show-red': row['CAPITAL(B)'] > 100 || row['CAPITAL(B)'] < 0}"
                                 (ngModelChange)="validationForJ('J1', i, 'CAPITAL(B)')"
                                 maxlength="9">
                          <span class="input-group-addon">%</span>
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <input type="text" 
                                 [(ngModel)]="row['PROFIT(E)']" 
                                 class="form-control input-sm"
                                 [ngClass]="{'show-red': row['PROFIT(E)'] > 100 || row['PROFIT(E)'] < 0}"
                                 (ngModelChange)="validationForJ('J1', i, 'PROFIT(E)')"
                                 maxlength="9">
                          <span class="input-group-addon">%</span>
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <input type="text" 
                                 [(ngModel)]="row['LOSS(E)']" 
                                 class="form-control input-sm"
                                 [ngClass]="{'show-red': row['LOSS(E)'] > 100 || row['LOSS(E)'] < 0}"
                                 (ngModelChange)="validationForJ('J1', i, 'LOSS(E)')"
                                 maxlength="9">
                          <span class="input-group-addon">%</span>
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <input type="text" 
                                 [(ngModel)]="row['CAPITAL(E)']" 
                                 class="form-control input-sm"
                                 [ngClass]="{'show-red': row['CAPITAL(E)'] > 100 || row['CAPITAL(E)'] < 0}"
                                 (ngModelChange)="validationForJ('J1', i, 'CAPITAL(E)')"
                                 maxlength="9">
                          <span class="input-group-addon">%</span>
                        </div>
                      </td>
                      <td>
                        <input type="checkbox" [(ngModel)]="row['DECREASE']">
                      </td>
                    </tr>
}
                    <tr>
                      <td>Total</td>
                      <td [ngClass]="{'show-red': totalForJ['PROFIT(B)'] !== 100}">
                        <span>{{totalForJ['PROFIT(B)']}}%</span>
                      </td>
                      <td [ngClass]="{'show-red': totalForJ['LOSS(B)'] !== 100}">
                        <span>{{totalForJ['LOSS(B)']}}%</span>
                      </td>
                      <td [ngClass]="{'show-red': totalForJ['CAPITAL(B)'] !== 100}">
                        <span>{{totalForJ['CAPITAL(B)']}}%</span>
                      </td>
                      <td [ngClass]="{'show-red': totalForJ['PROFIT(E)'] !== 100}">
                        <span>{{totalForJ['PROFIT(E)']}}%</span>
                      </td>
                      <td [ngClass]="{'show-red': totalForJ['LOSS(E)'] !== 100}">
                        <span>{{totalForJ['LOSS(E)']}}%</span>
                      </td>
                      <td [ngClass]="{'show-red': totalForJ['CAPITAL(E)'] !== 100}">
                        <span>{{totalForJ['CAPITAL(E)']}}%</span>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <!-- K Section - Partner's share of liabilities -->
                <table class="table table-bordered form-inline">
                  <tbody>
                    <tr>
                      <td [attr.rowspan]="(formattedScheduleKData['K1']?.length || 0) + 1">K</td>
                      <td>Partner's share of liabilities:</td>
                      <td>Nonrecourse(B)</td>
                      <td>Qualified nonrecourse financing(B)</td>
                      <td>Recourse(B)</td>
                      <td>Nonrecourse(E)</td>
                      <td>Qualified nonrecourse financing(E)</td>
                      <td>Recourse(E)</td>
                      <td>
                        Liability 
                        <i class="fa fa-info-circle" title="Check this box if Item K includes liability amounts from lower tier partnerships"></i>
                      </td>
                      <td>K3</td>
                      <td>K1 Final</td>
                      <td>Tax Year Begin(MM/DD/YYYY)<sup class="mandatory" title="Mandatory">* Mandatory</sup></td>
                      <td>Tax Year End(MM/DD/YYYY)<sup class="mandatory" title="Mandatory">* Mandatory</sup></td>
                    </tr>
                    @for (row of formattedScheduleKData['K1']; track $index; let i = $index) {
<tr>
                      <td>{{row.LEID + ' - ' + row.LE_NAME}}</td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" [(ngModel)]="row.NONRECOURSE" class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" [(ngModel)]="row.QUALIFIED" class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" [(ngModel)]="row.RECOURSE" class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" [(ngModel)]="row.NONRECOURSE_END" class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" [(ngModel)]="row.QUALIFIED_END" class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" [(ngModel)]="row.RECOURSE_END" class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <input type="checkbox" [(ngModel)]="row.LIABILITY" disabled>
                      </td>
                      <td>
                        <input type="checkbox" [(ngModel)]="row.LIABILITY_GUARANTEE">
                      </td>
                      <td>
                        <input type="checkbox" [(ngModel)]="row.K1_FINAL">
                      </td>
                      <td>
                        <div class="input-group date-input-group">
                          <input type="date" 
                                 class="form-control"
                                 [ngModel]="row.TAXYEARBEGIN | date:'yyyy-MM-dd'"
                                 (ngModelChange)="onDateChange(i, 'TAXYEARBEGIN', $event)">
                        </div>
                      </td>
                      <td>
                        <div class="input-group date-input-group">
                          <input type="date" 
                                 class="form-control"
                                 [ngModel]="row.TAXYEAREND | date:'yyyy-MM-dd'"
                                 (ngModelChange)="onDateChange(i, 'TAXYEAREND', $event)">
                        </div>
                      </td>
                    </tr>
}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Information About the Partner & Partner's Share of Current Year Income -->
        <table class="table table-bordered form-inline">
          <thead>
            <tr>
              <th class="data-align-center">Information About the Partner & Partner's Share of Current Year Income, Deductions, Credits, and Other Items</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table class="table table-bordered form-inline">
                  <tbody>
                    <tr>
                      <td rowspan="3">Legal Entity</td>
                      <td colspan="2">M</td>
                      <td colspan="2">N</td>
                      @if (taxYear > 2020) {
<td>16</td>
}
                      <td>21</td>
                      <td>22</td>
                      @if (taxYear > 2020) {
<td>23</td>
}
                    </tr>
                    <tr>
                      <td colspan="2">Did the partner contribute property with a built-in gain or loss?</td>
                      <td colspan="2">Partner's Share of Net Unrecognized Section 704(c) Gain or (Loss)</td>
                      @if (taxYear > 2020) {
<td rowspan="2">{{formattedScheduleKData['16'] && formattedScheduleKData['16'][0] ? formattedScheduleKData['16'][0].LINE_DESCRIPTION : ''}}</td>
}
                      <td rowspan="2">{{formattedScheduleKData['21'] && formattedScheduleKData['21'][0] ? formattedScheduleKData['21'][0].LINE_DESCRIPTION : ''}}</td>
                      <td rowspan="2">{{formattedScheduleKData['22'] && formattedScheduleKData['22'][0] ? formattedScheduleKData['22'][0].LINE_DESCRIPTION : ''}}</td>
                      @if (taxYear > 2020) {
<td rowspan="2">{{formattedScheduleKData['23'] && formattedScheduleKData['23'][0] ? formattedScheduleKData['23'][0].LINE_DESCRIPTION : ''}}</td>
}
                    </tr>
                    <tr>
                      <td>Yes</td>
                      <td>No</td>
                      <td>Beginning</td>
                      <td>Ending</td>
                    </tr>
                    @for (row of formattedScheduleKData['J1']; track $index; let i = $index) {
<tr>
                      <td>{{row.LEID + ' - ' + row.LE_NAME}}</td>
                      <td>
                        @if (formattedScheduleKData['M']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['M'][i]['YES']"
                               (ngModelChange)="unselectOther(i, 'YES')">
}
                      </td>
                      <td>
                        @if (formattedScheduleKData['M']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['M'][i]['NO']"
                               (ngModelChange)="unselectOther(i, 'NO')">
}
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" 
                                 [ngModel]="formattedScheduleKData['N']?.[i]?.['BEGINNING'] || ''"
                                 (ngModelChange)="formattedScheduleKData['N'] && formattedScheduleKData['N'][i] ? formattedScheduleKData['N'][i]['BEGINNING'] = $event : null"
                                 class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      <td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input type="text" 
                                 [ngModel]="formattedScheduleKData['N']?.[i]?.['ENDING'] || ''"
                                 (ngModelChange)="formattedScheduleKData['N'] && formattedScheduleKData['N'][i] ? formattedScheduleKData['N'][i]['ENDING'] = $event : null"
                                 class="form-control input-sm data-align-right">
                        </div>
                      </td>
                      @if (taxYear > 2020) {
<td>
                        @if (formattedScheduleKData['16']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['16'][i].ATTRIB_VALUE">
}
                      </td>
}
                      @if (taxYear <= 2020) {
<td>
                        @if (formattedScheduleKData['21']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['21'][i].ATTRIB_VALUE">
}
                      </td>
}
                      @if (taxYear > 2020) {
<td>
                        <div class="input-group" style="width:100%">
                          <span class="input-group-addon">$</span>
                          <input disabled type="text" 
                                 [ngModel]="formattedScheduleKData['21']?.[i]?.ATTRIB_VALUE || ''"
                                 class="form-control input-sm data-align-right">
                        </div>
                      </td>
}
                      <td>
                        @if (formattedScheduleKData['22']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['22'][i].ATTRIB_VALUE">
}
                      </td>
                      @if (taxYear > 2020) {
<td>
                        @if (formattedScheduleKData['23']?.[i]) {
<input type="checkbox" 
                              
                               [(ngModel)]="formattedScheduleKData['23'][i].ATTRIB_VALUE">
}
                      </td>
}
                    </tr>
}
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Line 14 Table -->
        @if (!showFormLoader && arePartnerPresent && !showLine14Loader && distinctCodes14.length > 0) {
<table class="table table-bordered form-inline scroll-table" 
              >
          <tbody>
            <tr>
              <td [attr.rowspan]="tableRow14">14</td>
              <td></td>
              @for (code of distinctCodes14; track $index) {
<td class="min-width">
                <label [title]="code">{{getCodeShortLabel(code)}}</label>
              </td>
}
            </tr>
            <tr>
              <td class="bold-value">{{entityList['LE Name']}}</td>
              @for (value of line14Data[firstLeidLine14]; track $index) {
<td class="bold-value data-align-right padding-value">
                {{formatNumber(value.CODE_VALUE)}}
              </td>
}
            </tr>
            @for (leid of objectKeys(line14Data); track $index) {
<tr>
              <td>{{line14Data[leid][0].LEID + ' - ' + line14Data[leid][0].LE_NAME}}</td>
              @for (value of line14Data[leid]; track $index) {
<td>
                <input class="form-control input-md numText data-align-right" 
                       style="width: 100%;"
                       type="text"
                       [(ngModel)]="value.ADJ_AMT_1"
                       (ngModelChange)="line14ValueChanges()">
              </td>
}
            </tr>
}
            <tr>
              <td class="bold-value">Total</td>
              @for (total of line14Total; track $index) {
<td class="bold-value data-align-right padding-value">
                {{formatNumber(total)}}
              </td>
}
            </tr>
            <tr>
              <td class="bold-value">Variance</td>
              @for (variance of variances14; track $index) {
<td class="bold-value data-align-right padding-value">
                <span [ngClass]="{'show-red-text': variance < 0}">
                  @if (variance < 0) {
<span>({{variance * -1}})</span>
}
                  @if (variance >= 0) {
<span>{{variance}}</span>
}
                </span>
              </td>
}
            </tr>
          </tbody>
        </table>
}

        <!-- Line 20 Table -->
        @if (!showFormLoader && arePartnerPresent && !showLine20Loader && distinctCodes20.length > 0) {
<table class="table table-bordered form-inline scroll-table" 
              >
          <tbody>
            <tr>
              <td [attr.rowspan]="tableRow20">20</td>
              <td></td>
              @for (code of distinctCodes20; track $index) {
<td class="min-width">
                <label [title]="code">{{getCodeShortLabel(code)}}</label>
              </td>
}
            </tr>
            <tr>
              <td class="bold-value">{{entityList['LE Name']}}</td>
              @for (value of line20Data[firstLeidLine20]; track $index) {
<td class="bold-value data-align-right padding-value">
                {{formatNumber(value.CODE_VALUE)}}
              </td>
}
            </tr>
            @for (leid of objectKeys(line20Data); track $index) {
<tr>
              <td>{{line20Data[leid][0].LEID + ' - ' + line20Data[leid][0].LE_NAME}}</td>
              @for (value of line20Data[leid]; track $index) {
<td>
                <input class="form-control input-md numText data-align-right" 
                       style="width: 100%;"
                       type="text"
                       [(ngModel)]="value.ADJ_AMT_1"
                       (ngModelChange)="line20ValueChanges()">
              </td>
}
            </tr>
}
            <tr>
              <td class="bold-value">Total</td>
              @for (total of line20Total; track $index) {
<td class="bold-value data-align-right padding-value">
                {{formatNumber(total)}}
              </td>
}
            </tr>
            <tr>
              <td class="bold-value">Variance</td>
              @for (variance of variances20; track $index; let i = $index) {
<td class="bold-value data-align-right padding-value">
                <span [ngClass]="{'show-red-text': variance < 0}">
                  @if (!distinctCodes20[i]?.includes('Code AX1') && !distinctCodes20[i]?.includes('Code AX2')) {

                    @if (variance < 0) {
<span>({{variance * -1}})</span>
}
                    @if (variance >= 0) {
<span>{{variance}}</span>
}
                  
}
                </span>
              </td>
}
            </tr>
          </tbody>
        </table>
}
      </div>
}
    </div>
  </div>
}

  <!-- Modal Footer -->
  @if (!minimise) {
<div class="modal-footer">
    <button class="btn btn-info btn-sm" type="button" (click)="save()" [disabled]="isSaving">
      Save and Proceed
      @if (isSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    </button>
    <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">Reset</button>
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
}
</div>

